import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import './styles/PermissionErrorModal.css';

const PermissionErrorModal = ({
  isOpen,
  deviceType, // 'camera' or 'microphone'
  onClose
}) => {

  if (!isOpen) return null;

  const deviceName = deviceType === 'camera' ? 'Camera' : 'Microphone';
  const deviceNameLower = deviceType === 'camera' ? 'camera' : 'microphone';

  const message = `You haven't granted permission to access your ${deviceNameLower}. To use the ${deviceNameLower} during the meeting, please enable ${deviceNameLower} permissions in your browser settings.`;

  return (
    <>
      {/* Animation styles */}
      <style>
        {`
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          
          /* Responsive styles */
          @media (max-width: 480px) {
            .permission-error-modal-content {
              padding: 24px !important;
            }
            .permission-error-modal-title {
              font-size: 24px !important;
            }
            .permission-error-modal-message {
              font-size: 14px !important;
            }
          }
        `}
      </style>

      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001,
        backdropFilter: 'blur(4px)'
      }}>
        <div
          className="permission-error-modal-content"
          style={{
            backgroundColor: '#1C1F2E',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '90%',
            width: '400px',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
            position: 'relative',
            animation: 'modalFadeIn 0.3s ease-out'
          }}>
          {/* Close button */}
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'transparent',
              border: 'none',
              color: '#9CA3AF',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#FFFFFF';
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#9CA3AF';
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            <X size={20} />
          </button>

          {/* Icon container */}
          <div style={{
            width: '64px',
            height: '64px',
            margin: '0 auto 24px',
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <AlertCircle size={32} style={{ color: '#EF4444' }} />
          </div>

          {/* Title */}
          <h2
            className="permission-error-modal-title"
            style={{
              color: '#FFFFFF',
              fontSize: '28px',
              fontWeight: '600',
              textAlign: 'center',
              margin: '0 0 8px 0',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}>
            {deviceName} Permission Required
          </h2>

          {/* Message */}
          <p
            className="permission-error-modal-message"
            style={{
              color: '#9CA3AF',
              fontSize: '16px',
              textAlign: 'center',
              margin: '0',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              lineHeight: '1.5'
            }}>
            {message}
          </p>
        </div>
      </div>
    </>
  );
};

export default PermissionErrorModal;

